module.exports = __webpack_public_path__ + "resource/img/image047.f28e80ef.png";